export const cus_data = [
  {
    customer_code: 1,
    customer_name: "Chantal",
    contact_no: "89-247-3345",
    email: "cchstney0@ft.com",
    door_no: "Drive",
    street: "Jenifer",
    city: "Ivouani",
    postal_code: "KM",
    total_payable: 0.0,
  },
  {
    customer_code: 2,
    customer_name: "Dana",
    contact_no: "78-076-4337",
    email: "dgelly1@google.cn",
    door_no: "Way",
    street: "Center",
    city: "Wangzuizi",
    postal_code: "CN",
    total_payable: 0.0,
  },
  {
    customer_code: 3,
    customer_name: "Margaretta",
    contact_no: "12-148-8738",
    email: "mbelliveau2@istockphoto.com",
    door_no: "Way",
    street: "Ruskin",
    city: "Munkfors",
    postal_code: "SE",
    total_payable: 0.0,
  },
  {
    customer_code: 4,
    customer_name: "Julienne",
    contact_no: "22-298-1004",
    email: "jmashro3@china.com.cn",
    door_no: "Crossing",
    street: "Hallows",
    city: "Tlogotunggal",
    postal_code: "ID",
    total_payable: 0.0,
  },
  {
    customer_code: 5,
    customer_name: "Lee",
    contact_no: "05-578-7634",
    email: "lzanutti4@alexa.com",
    door_no: "Crossing",
    street: "Sunnyside",
    city: "Babice",
    postal_code: "PL",
    total_payable: 0.0,
  },
  {
    customer_code: 6,
    customer_name: "Dar",
    contact_no: "62-028-8799",
    email: "dmonier5@ted.com",
    door_no: "Hill",
    street: "Moulton",
    city: "Esperanza",
    postal_code: "AR",
    total_payable: 0.0,
  },
  {
    customer_code: 7,
    customer_name: "Hollie",
    contact_no: "50-855-0091",
    email: "hbartosik6@slashdot.org",
    door_no: "Avenue",
    street: "7th",
    city: "Xiaotang",
    postal_code: "CN",
    total_payable: 0.0,
  },
  {
    customer_code: 8,
    customer_name: "Georgia",
    contact_no: "94-992-6779",
    email: "gkeeton7@yelp.com",
    door_no: "Point",
    street: "Westerfield",
    city: "Jiatou",
    postal_code: "CN",
    total_payable: 0.0,
  },
  {
    customer_code: 9,
    customer_name: "Diena",
    contact_no: "35-765-2792",
    email: "ddragon8@ft.com",
    door_no: "Parkway",
    street: "Iowa",
    city: "Beima",
    postal_code: "CN",
    total_payable: 0.0,
  },
];
